// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1i0PD","info":"PatientInfo_info__2QPxJ"};